import { Stack } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { useContext, useEffect, useState } from 'react';
import { Therapy } from './Therapy';
import { useIsDesktop } from 'Hooks';
import { ITherapySuppliersResult } from 'API/Suppliers/suppliers';
import { Pagination } from './Pagination';
import { SUPPLIERS_ID } from 'Enum/suppliers';

export const Mapper = () => {
  const { suppliers, suppliersId } = useContext(SuppliersContext);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const isDesktop = useIsDesktop();

  useEffect(() => {
    setCurrentPage(0);
  }, [suppliers]);

  const PAGINATION_LIMIT = 10;

  const mapResultsToComponent = (
    results: ITherapySuppliersResult[],
    Component: React.ComponentType<any>
  ) => {
    const startIndex = PAGINATION_LIMIT * currentPage;
    const endIndex = PAGINATION_LIMIT * currentPage + PAGINATION_LIMIT;
    return results
      .slice(startIndex, endIndex)
      .map((result: ITherapySuppliersResult, index: number) => {
        return <Component key={index} data={result} />;
      });
  };

  const genericResultsHandler = () => {
    switch (suppliersId) {
      case SUPPLIERS_ID.MENTAL_THERAPY:
        return mapResultsToComponent(suppliers.filteredResults, Therapy);
      default:
        return null;
    }
  };

  return (
    <Stack
      direction='column'
      gap={isDesktop ? '24px' : '16px'}
      sx={{
        mt: '16px',
      }}
      aria-live='polite'
      aria-atomic='true'
    >
      {genericResultsHandler()}
      {suppliers.filteredResults.length > PAGINATION_LIMIT && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={Math.ceil(
            suppliers.filteredResults.length / PAGINATION_LIMIT - 1
          )}
        />
      )}
    </Stack>
  );
};
